
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[placementName]",
      function () {
        return require("private-next-pages/event/[placementName]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[placementName]"])
      });
    }
  